<template src="./Footer.html"></template>
<style src="./Footer.scss" lang="scss"></style>

<script>
	import Teaser from '@/components/Teaser/Teaser';
	import Simple from '@/components/Simple/Simple';

	export default {
		components: {
			'hp-teaser': Teaser,
			'hp-simple': Simple
		},
		props: ['elements']
	};
</script>
